<template>
  <div style="height:100%">
    <BaseContainer style="height:100%" class="one_table">
      <TableMain name="one table" ref="TestTable2" :fields="fields" :title="table_title.title1"
        :show_query_container="true" :show_toolbar_container="true" :show_pagination_container="true"
        :show_date_picker="false" :show_toolbar="false" :show_filter="true" :date_picker_label="date_picker_label"
        :query_button_label="query_lable" :isBusy="isBusy" @on_query="on_query" @state_change="state_change"
        :show_toolbar_button="[0, 0, 0, 0, 0]" @tool_invoke="tool_invoke" tableref="f90538bb48d04ed38179ccd73616bdaa">
        <template #query>
          {{ $t("common.local_currency_code") }}：<el-input clearable size="small" style="width: 120px"
            v-model="dispFromCurrencyCode"></el-input>
        </template>
      </TableMain>
    </BaseContainer>
  </div>
</template>

<script>
import * as ExchRateController from "../../controllers/base/ExchRateController";
import BaseContainer from "../components/BaseContainer";
import TestQueryPanel from "../components/base/TestQueryPanel";
import BaseModal from "../components/modals/baseModal";
import TableMain from "../components/table/TableMain";

export default {
  name: "ExchRate",
  components: {
    BaseContainer,
    TableMain,
    BaseModal,
    TestQueryPanel,
  },
  data() {
    return {
      date_picker_label: "common.search",
      query_lable: this.$t("common.query"),
      table_title: {
        title1: "table_currency",
      },
      fields: ExchRateController.fields,
      dataForm: _.cloneDeep(ExchRateController.dataForm),
      rules: ExchRateController.rules,
      dispFromCurrencyCode: "",
      isBusy: false,
    };
  },
  created() { },
  methods: {
    //#region 查询
    async on_query(set_data, date_range) {
      this.isBusy = true;
      let _params = {
        dispFromCurrencyCode: { like: "%" + this.dispFromCurrencyCode + "%" },
      };
      set_data([]);
      let _result = await ExchRateController.methods.getData(_params);
      if (!_.isNull(_result) && _result && _result.length > 0) {
        set_data(_.orderBy(_result[0], ["modifiedDateTime"], ["desc"]));
      }
      this.isBusy = false;
    },
    //#endregion

    //#region 状态切换
    state_change(data, cb) { },
    //#endregion

    //#region 打印导出
    tool_invoke(data, cb) { },
    //#endregion
  },
};
</script>
